import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { IoIosClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import ReactStars from "react-rating-stars-component";
import { render } from "react-dom";
import {createRating} from "../../../services/operations/courseDetailsAPI";

function CourseReviewModal({setReviewModal}) {
    
    const {user} = useSelector((state)=>state.profile);
    const {token} = useSelector((state)=>state.auth);
    const {courseEntireData} = useSelector((state)=> state.viewCourse);
    const {handleSubmit,register,setValue,formState:{errors}} = useForm();

    useEffect(()=>{
        setValue("courseExperience","");
        setValue("courseRating",0);
    },[])

    async function onSubmit(data)
    {
        // console.log("Data: ",data);
        // console.log("Response: ",courseEntireData._id);
        const response = await createRating({
            courseId: courseEntireData._id,
            rating: data.courseRating,
            review: data.courseExperience,
        },token);
        setReviewModal(false);
        // console.log("Response: ",response);
    }

    function ratingChanged(newRating)
    {
        // when the value of rating changes
        // we are going to change the value of stars
        setValue("courseRating",newRating);
    }

    return (
        <div className="fixed inset-0 z-[1000] !mt-0 grid h-screen w-screen place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm">
            <div className="my-10 w-11/12 max-w-[700px] rounded-lg border border-richblack-400 bg-richblack-800">
                {/* Modal Header */}
                <div className="flex items-center justify-between rounded-t-lg bg-richblack-700 p-5">
                    <p className="text-xl font-semibold text-richblack-5">Add Review</p>
                    <button onClick={()=>setReviewModal(false)}><IoIosClose className="text-2xl text-richblack-5"/></button>
                </div>
                {/* Modal */}
                <div className="p-6">
                    <div className="flex items-center justify-center gap-x-4">
                        <img src={user?.image} alt={`${user?.firstName}_image`} 
                        className="aspect-square w-[50px] rounded-full object-cover"/>
                        <div>
                            <p className="font-semibold text-richblack-5">{user?.firstName} {user?.lastName}</p>
                            <p className="text-sm text-yellow-25">Posting Publicly</p>
                        </div>
                    </div>


                    <form onSubmit={handleSubmit(onSubmit)} className='mt-6 flex flex-col items-center'>
                        <ReactStars
                            count={5}
                            onChange={ratingChanged}
                            size={24}
                            activeColor={"#ffd700"}
                        />
                        <div className="flex w-11/12 flex-col space-y-2">
                            <label htmlFor="courseExperience" className='text-richblack-50'>
                                Add Your Experience <sup className="text-pink-200">*</sup>
                            </label>
                            <textarea name="courseExperience" id="courseExperience" placeholder='Add your experience here'
                                {...register("courseExperience",{required: true})}
                            cols="30" rows="10"
                            // className='form-style min-h-[130px] w-full'
                            className="form-style resize-x-none min-h-[130px] w-full"
                            ></textarea>
                            {
                                errors.courseExperience && (
                                <span className='text-richblack-100'>
                                    Please add your experience
                                </span>
                                )
                            }
                            <div className="mt-6 flex justify-end gap-x-2">
                                {/* className="w-11/12" */}
                                {/* Save button */}
                                <button onClick={()=>setReviewModal(false)}
                                    className={`flex cursor-pointer items-center gap-x-2 rounded-md bg-richblack-300 py-[8px] px-[20px] font-semibold text-richblack-900`}
                                >
                                    Cancel
                                </button>
                                <button type='submit' className='bg-yellow-50 font-semibold px-4 py-2 rounded-md'>
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CourseReviewModal;